import { CopyOutlined } from '@ant-design/icons';
import { message, Tooltip } from 'antd';
import React from 'react';

interface CopyableIdProps {
  value: string;
}

export function CopyableId({ value }: CopyableIdProps) {
  const [isEntered, setIsEntered] = React.useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(value);
    message.success('ID가 클립보드에 복사되었습니다.');
  };

  const handleEnter = () => {
    setIsEntered(true);
  };

  const handleLeave = () => {
    setIsEntered(false);
  };

  return (
    <Tooltip title={value}>
      <div
        role="presentation"
        onClick={handleClick}
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
      >
        <span style={{ fontSize: 12 }}>{value?.slice(0, 8)}...</span>
        <CopyOutlined
          style={{
            marginLeft: 4,
            color: 'gray',
            opacity: isEntered ? 1 : 0,
            transition: 'opacity 0.3s ease',
          }}
        />
      </div>
    </Tooltip>
  );
}
